import React from 'react';
import PropTypes from 'prop-types';
import { Card, Row, Col, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { rootPaths } from 'routes/paths';
import { useTranslation } from 'react-i18next';
import Logo from 'components/common/logo';

const clearAppCache = async () => {
  if ('caches' in window) {
    const cacheNames = await caches.keys();
    await Promise.all(cacheNames.map((name) => caches.delete(name)));
  }
};

const ErrorFallback = ({ isRepeatedFailure }) => {
  const { t } = useTranslation();

  const handleGoToDashboard = async () => {
    try {
      await clearAppCache();
    } catch (e) {
      console.error('Failed to clear app cache:', e);
    }
    window.location.href = `/${rootPaths.dashboardRoot}`;
  };

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center">
      <Row className="w-100 justify-content-center">
        <Col md={8} lg={6} xl={5}>
          <Logo />
          <Card className="text-center">
            <Card.Body className="p-5">
              <div className="display-1 text-300 fs-error">
                <FontAwesomeIcon icon={faExclamationTriangle} />
              </div>
              <p className="lead mt-4 text-800 font-sans-serif fw-semibold">
                {t('errorFallback.title')}
              </p>
              <hr />
              <p>
                {isRepeatedFailure
                  ? t('errorFallback.stillTroubleDescription', {
                      appName: process.env.REACT_APP_ORGANIZATION_NAME || 'GetPlan',
                    })
                  : t('errorFallback.description')}
              </p>
              <Button
                className="btn btn-primary btn-sm mt-3"
                onClick={handleGoToDashboard}
              >
                {t('errorFallback.goToDashboard')}
              </Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

ErrorFallback.propTypes = {
  isRepeatedFailure: PropTypes.bool,
};

ErrorFallback.defaultProps = {
  isRepeatedFailure: false,
};

export default ErrorFallback;